import React, { useState } from "react";
import "./styles.css";
import Form from "react-bootstrap/Form";

const ProductDetailRigthSide = () => {
  const [quantity, setQuantity] = useState(5);
  const price = 899
  const total = price * quantity

  const onChangeRest = () => {
    if (quantity === 0) {
      setQuantity(0);
    } else {
      setQuantity(quantity - 1);
    }
  };

  const onChangePlus = () => {
    setQuantity(quantity + 1);
  };
  return (
    <div className="productRightSide">
      <h1>Protein Animal</h1>
      <h2>${price}MXN</h2>
      <div className="productRightSideSelects">
        <div>
          <p>Sabor </p>
          <Form.Select>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </Form.Select>
        </div>
        <div>
          <p>Contenido </p>
          <Form.Select>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </Form.Select>
        </div>
        <div>
          <p>Cantidad </p>
          <Form.Select>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </Form.Select>
        </div>
        <div className="productRightSideQuantity">
          <p>Cantidad </p>
          <div className="productRightSideQuantityLabelOptions">
            <p onClick={onChangeRest}>-</p>
            <span>{quantity}</span>
            <p onClick={onChangePlus}>+</p>
          </div>
        </div>
        <div className="productRightSideTotal">
            <p >Total</p>
            <h3>${total} MXN</h3>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailRigthSide;
